import React, { useId } from "react";
import "./colorPicker.css";

const fallbackHex = (value) =>
  /^#([0-9a-fA-F]{6})$/.test(value) ? value : "#000000";

export default function ColorPicker({
  value,
  onChange: _onChange,
  onBlur,
  id,
}) {
  const generatedId = useId().replace(/:/g, "");
  const colorInputId = id || `color-picker-${generatedId}`;
  const swatchValue = fallbackHex(value);

  return (
    <div className="colorPicker">
      <label
        className="colorPickerLabel"
        htmlFor={colorInputId}
        style={{ background: swatchValue }}
      >
        <input
          type="color"
          id={colorInputId}
          className="colorPickerInput"
          value={swatchValue}
          onChange={(evt) => {
            _onChange(evt.target.value);
          }}
          onBlur={onBlur}
        />
      </label>
      <input
        type="text"
        className="colorPickerInputsText drop-shadow-2xl"
        value={value || ""}
        aria-label="Color hex value"
        onChange={(evt) => {
          _onChange(evt.target.value);
        }}
        onBlur={onBlur}
      />
    </div>
  );
}
